import {
  CircleCheckIcon,
  CircleDashedIcon,
  ClipboardIcon,
  ClipboardSignatureIcon,
  EyeIcon,
  EyeOffIcon,
  LoaderIcon,
} from 'lucide-react'
import { ReactElement } from 'react'

import { AlertStatus } from '@/gen/inventory/v1/alert_pb'

import { cn } from '@/lib/ui/style-helpers'

const alertIcons: Record<AlertStatus, ReactElement> = {
  [AlertStatus.OPEN]: <CircleDashedIcon className='w-4 text-main-foreground-danger' />,
  [AlertStatus.ONGOING]: <LoaderIcon className='w-4 text-main-foreground-secondary' />,
  [AlertStatus.RESOLVED]: <CircleCheckIcon className='w-4 text-main-foreground-success' />,
  [AlertStatus.ACCEPTED]: <EyeIcon className='w-4 text-main-foreground-secondary' />,
  [AlertStatus.NOT_APPLICABLE]: <EyeOffIcon className='w-4 text-main-foreground-secondary' />,
  [AlertStatus.UNSPECIFIED]: <></>,
}

export const AlertStatusIcon = ({ status }: { status: AlertStatus }) => {
  return alertIcons[status]
}

export type AlertStatusSymbolProps = React.ComponentProps<typeof ClipboardSignatureIcon>

export const AlertStatusSymbol = (props: AlertStatusSymbolProps) => (
  <ClipboardIcon {...props} className={cn('w-2.5', props.className)} />
)
